import apiClient from './apiClient';

class ProjectPlanService {
  async getPlanIssues(projectId, weekRanges) {
    try {
      // Send a compact date range instead of every fully-expanded week.
      // The server regenerates the weekly buckets, keeping the URL tiny so it
      // can never hit nginx/proxy URL-length limits regardless of span.
      const start_date = weekRanges[0]?.start_date;
      const end_date = weekRanges[weekRanges.length - 1]?.start_date;
      const data = await apiClient.get(`/projects/${projectId}/plan_issues`, {
        params: { start_date, end_date }
      });
      return data;
    } catch (error) {
      const err = error.response?.data;
      throw new Error(err?.error || 'Failed to fetch plan issues');
    }
  }

  async saveEstimate(projectId, issueKey, weekStartDate, hours) {
    try {
      await apiClient.post(`/projects/${projectId}/plan_estimates`, {
        issue_key: issueKey,
        week_start_date: weekStartDate,
        hours
      });
    } catch (error) {
      const err = error.response?.data;
      throw new Error(err?.error || 'Failed to save estimate');
    }
  }
}

export const projectPlanService = new ProjectPlanService();